import { useEffect, useState } from "react";
import Axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { object, string, boolean} from 'yup';
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";

//const tipos = ['Ingreso', 'Ajuste', 'Envio']

export default function FormEncabezado({ url, urlPost, headers, setAjusteListener, cleanProductos, formRef, productos, setModal, setRawData, setValidateStock }) {

    const bodegas = useSelector(state => state.auth.bodegas)
    const primerIdBodega = bodegas[0].IdBodega
    const { IdEmp } = useSelector(state => state.auth)

    const [proveedores, setProveedores] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            try{
                const res = await Axios({
                    method: 'GET',
                    url,
                    headers,
                    params: {
                        "opcion": "PROVEEDORES"
                    }
                })

                setProveedores(res.data.msg)
                setLoading(false)
            }catch(err){
                console.log(err)
            }
        }

        fetchData()
    }, [])

    const cookies = new Cookies();
    const urlSeguridadApi = cookies.get('__urlSeguridad')
    const [tipos, setTipos] = useState([])
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await Axios({
                    method: 'GET',
                    url: urlSeguridadApi + '/seguridad/opciones',
                    headers,
                    params: {
                        IdEmp,
                        Menu: "Ingresos, Ajustes y Envios de Bodega"
                    }
                })

                const tiposArr = res.data.msg.map(x => x.Opcion)
                setTipos(tiposArr)

            } catch (err) {
                console.log(err)
            }
        }

        fetchData()
    }, [])

    //POST de movimiento de bodegas
    const fetchData = async (data) => {
        try{
            await Axios({
                method: 'POST',
                url: urlPost,
                headers,
                data
            })

        }catch(err){
            setModal({
                ok: false,
                msg: 'Por favor, intentelo de nuevo.',
                show: true,
            })
            console.log(err)
        }
    }

    const handleSubmit = ({IdBodega, Ajuste, FechaRef, ...values }) => {
        IdBodega = IdBodega === '' ? primerIdBodega : IdBodega
        //Revisar que el movimiento de bodega no este vacio
        if(productos.length === 0){
            return setModal({
                msg: 'Seleccione al menos un producto',
                ok: false,
                show: true
            })
        }

        //Revisar si todos los productos llevan cantidad valida
        if(productos.some(producto => producto.qty === 0)){
            return setModal({
                msg: 'Ingrese la cantidad en todos los productos',
                ok: false,
                show: true
            })
        }

        //Formateo de data a enviar en axios
        const DetalleProductos = productos.map(({ IdProducto, qty, Precio }) => ({
            IdProducto,
            IdBodega,
            Cantidad: qty,
            Costo: Precio
        }))
        const data = JSON.stringify({
            ...values,
            FechaRef: FechaRef.split('-').join(''),
            Ajuste,
            DetalleProductos,
            IdEmp,
            "HostName":"DEV07",
            "IpHost":"131.107.1.235",  
            "OS":"Windows"
        })

        fetchData(data);
        
        setModal({
            msg: '¡Movimiento de bodega realizado con exito!',
            ok: true,
            show: true
        })
    }

    const handleBodega = async (e, setFieldValue) => {

        setFieldValue('IdBodega', e.target.value);

        try{
            const res = await Axios({
                method: 'GET',
                url,
                headers,
                params: {
                    "opcion": "PRODUCTOSINGR",
                    "IdBodega": e.target.value
                } 
            })
            setRawData(res.data.msg)
            setLoading(false)

        }catch(err){
            console.log(err)
        }
    }

    const handleTipo = (e, setFieldValue) => {
        setFieldValue('Sel', e.target.value)
        setFieldValue('Ajuste', '')
        setFieldValue('IdProveedor', '')
        setFieldValue('Referencia', '')
        setFieldValue('Fecharef', '')
        cleanProductos()

        e.target.value === 'Envio'
            ? setValidateStock(true)
            : setValidateStock(false) 
    }

    if(!loading){
        return (
            <Formik
                innerRef={formRef}
                initialValues={{ Sel: '', IdProveedor: '',  Ajuste: '', Referencia: '', FechaRef: '', Observaciones: '', IdBodega: '', Recibe: '' }}
                validationSchema={object({
                    'Envio'    : string().required('Dato obligatorio'),
                    'Fecha'    : string().required('Dato obligatorio'),
                    'Proveedor': string().required('Dato obligatorio'),
                    'Sede'     : string().required('Dato obligatorio'),
                    'Empresa'  : string().required('Dato obligatorio'),
                })}
                onSubmit={handleSubmit}
            >
                {
                    ({ values, setFieldValue }) => {
                        return(
                            <Form>
                                <div className="px-4 py-5 sm:p-6">
                                    <div className="lg:grid lg:grid-cols-3 lg:gap-5 ml-3">
                                        <div className="lg:col-span-1">
                                            <h3 className="text-lg font-medium leading-6 text-white">1. Rellenar los campos</h3>
                                            <p className="mt-1 text-sm text-grisMira">Rellene la información respectiva al envío.</p>
                                        </div>
                                        <div className="mt-5 lg:col-span-2 lg:mt-0">
                                            <div className="grid grid-cols-6 gap-3">
                
                                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                                    <div className="flex justify-between">    
                                                        <label className="block text-sm font-medium text-grisMira">
                                                            Número de envío
                                                        </label>
                                                        <ErrorMessage component="p" name="Referencia" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                    </div>
                                                    <Field 
                                                        name='Referencia' 
                                                        type='text' 
                                                        className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm`}
                                                    />
                                                </div>
                
                                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                                    <div className="flex justify-between">    
                                                        <label className="block text-sm font-medium text-grisMira">
                                                            Fecha
                                                        </label>
                                                        <ErrorMessage component="p" name="FechaRef" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                    </div>
                                                    <Field 
                                                        name='FechaRef' 
                                                        type='date' 
                                                        min='1900-01-01'
                                                        max='2075-12-31'
                                                        className={`cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm`}
                                                    />
                                                </div>

                                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                                    <div className="flex justify-between">    
                                                        <label className="block text-sm font-medium text-grisMira">
                                                            Proveedor
                                                        </label>
                                                        <ErrorMessage component="p" name="Sel" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                    </div> 
                                                    <select 
                                                        onChange={(e) => handleTipo(e, setFieldValue)} 
                                                        className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                    >
                                                        <option value=''>-------------</option>
                                                        {tipos.map((tipo, key) => <option key={key} value={tipo}>{tipo}</option>)}
                                                    </select>
                                                </div>
                
                                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                                    <div className="flex justify-between">
                                                        <label className="block text-sm font-medium text-grisMira">
                                                            Sede
                                                        </label>
                                                        <ErrorMessage component="p" name="IdProveedor" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                    </div>
                                                    <Field 
                                                        disabled={values.Sel === 'Envio'} 
                                                        name='IdProveedor' 
                                                        as='select' 
                                                        className={`
                                                        ${values.Sel === 'Envio' ? 'bg-gray-400/90 cursor-not-allowed' : null}
                                                        cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                        `}
                                                    >
                                                        <option value=''>-------------</option>
                                                        {proveedores.map((prov, key) => <option key={key} value={prov.IdProveedor}>{prov.Nombre}</option>)}
                                                    </Field>
                                                </div>
                


                                                <div className={values.Sel === 'Envio' ? 'col-span-3' : 'col-span-full'}>
                                                    <div className="flex justify-between">    
                                                        <label className="block text-sm font-medium text-grisMira">
                                                            Empresa
                                                        </label>
                                                        <ErrorMessage component="p" name="IdBodega" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                    </div>
                                                    <Field 
                                                        onChange={e => handleBodega(e, setFieldValue)}
                                                        name='IdBodega' 
                                                        as='select' 
                                                        className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                        {bodegas.map((bodega, key) => bodega.IdBodega !== 0 ? <option key={key} value={bodega.IdBodega}>{bodega.NombreBodega}</option> : null)}
                                                    </Field>
                                                </div>

                                                {
                                                    values.Sel === 'Ajuste' ?
                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <div className="flex justify-between">    
                                                                <label className="block text-sm font-medium text-grisMira mb-1">
                                                                    Ajuste
                                                                </label>
                                                                <ErrorMessage component="p" name="Ajuste" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                            </div>
                                                            <div className="flex flex-col gap-2 bg-secundarioMira  rounded-lg shadow-xl py-1 px-3 pb-2">
                                                                <div className="w-full flex gap-2 justify-between">
                                                                    <label className="block text-sm font-medium text-grisMira">Positivo</label>
                                                                    <input 
                                                                        type='checkbox' 
                                                                        className="cursor-pointer mt-1 block w-1/3 rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm text-green-500"
                                                                        onChange={(e) => {
                                                                            setFieldValue('Ajuste', true)
                                                                            setAjusteListener(false)
                                                                            cleanProductos()
                                                                        }}
                                                                        checked={values.Ajuste ? true : false}
                                                                    />
                                                                </div>

                                                                <div className="w-full flex gap-2 justify-between">
                                                                    <label className="block text-sm font-medium text-grisMira">Negativo</label>
                                                                    <input 
                                                                        type='checkbox' 
                                                                        className="cursor-pointer mt-1 block w-1/3 rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm text-red-500"
                                                                        onChange={(e) => {
                                                                            setFieldValue('Ajuste', false)
                                                                            setAjusteListener(true)
                                                                            cleanProductos()
                                                                        }}
                                                                        checked={values.Ajuste !== '' && !values.Ajuste ? true : false}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    : null
                                                }
                                                
                                                {/*values.Sel === 'Envio' &&
                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                                        <div className="flex justify-between">    
                                                            <label className="block text-sm font-medium text-grisMira">
                                                                Recibe
                                                            </label>
                                                            <ErrorMessage component="p" name="Recibe" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                        </div>
                                                        <Field 
                                                            name='Recibe' 
                                                            type='text' 
                                                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                        />
                                                    </div>
                                            */}
                                                
                                                <div className={`col-span-6 sm:col-span-6 lg:col-span-4 ${values.Sel === 'Ajuste' ? 'lg:col-span-4' : 'lg:col-span-full'}`}>
                                                    <label className="block text-sm font-medium text-grisMira">Encargado</label>
                                                    <Field name='Observaciones' as='label' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"/>
                                                </div>
                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )
                    }
                }
            </Formik>
    
        )   
    }
}